/* eslint-disable enforce-ids-in-jsx/missing-ids */
import React from 'react'

import useAnimatedCounter from 'utils/hooks/useAnimatedCounter'

import { Participants } from 'components/lib/DesignSystem/Icons'
import Tooltip from 'components/lib/DesignSystem/V3/Tooltip'

import {
  BottomDetailDivider,
  BottomDetailItem,
  BottomDetailsContainer,
  BottomDetailStrong,
  BottomDetailVerifiedTrigger,
  DepartmentList,
  MostEffectiveDepartments,
} from '../styles'

import AgentVerifiedMark from './AgentVerifiedMark'

const BottomDetails = ({
  campaignId,
  employeesCount,
  hasExcludedDuplicates,
  behavioralRiskPercentage,
  departments,
}) => {
  const animatedEmployeesCount = useAnimatedCounter(employeesCount)

  return (
    <BottomDetailsContainer
      id={`Psima_Dashboard_BottomDetails_div-${campaignId}`}
      data-testid={`Psima_Dashboard_BottomDetails_div-${campaignId}`}
    >
      <BottomDetailItem
        id={`Psima_Dashboard_EmployeesStat_div-${campaignId}`}
        data-testid={`Psima_Dashboard_EmployeesStat_div-${campaignId}`}
      >
        <Participants width="16px" height="16px" fill="var(--sub-text-color)" />
        <BottomDetailStrong>{animatedEmployeesCount}</BottomDetailStrong>
        <span>Employees</span>
        {hasExcludedDuplicates && (
          <Tooltip
            id={`Psima_Dashboard_DuplicatesExcluded_tooltip-${campaignId}`}
            side="top"
            arrow
            content="This audience includes employees already assigned to a better-fit simulation. They were excluded here so no one is targeted twice."
          >
            <BottomDetailVerifiedTrigger
              data-testid={`Psima_Dashboard_DuplicatesExcluded_div-${campaignId}`}
            >
              <AgentVerifiedMark variant="banner" />
            </BottomDetailVerifiedTrigger>
          </Tooltip>
        )}
      </BottomDetailItem>
      <BottomDetailDivider />
      <BottomDetailItem
        id={`Psima_Dashboard_BehavioralRiskStat_div-${campaignId}`}
        data-testid={`Psima_Dashboard_BehavioralRiskStat_div-${campaignId}`}
      >
        <BottomDetailStrong>{behavioralRiskPercentage}%</BottomDetailStrong>
        <span>have behavioral risk</span>
      </BottomDetailItem>
      <BottomDetailDivider />
      <BottomDetailItem
        id={`Psima_Dashboard_DepartmentsStat_div-${campaignId}`}
        data-testid={`Psima_Dashboard_DepartmentsStat_div-${campaignId}`}
      >
        <MostEffectiveDepartments>
          <span>Most effective in</span>
          <DepartmentList>{departments || '-'}</DepartmentList>
        </MostEffectiveDepartments>
      </BottomDetailItem>
    </BottomDetailsContainer>
  )
}

export default BottomDetails
